import { render, staticRenderFns } from "./perjanjianKerja.vue?vue&type=template&id=863fdbc0"
import script from "./perjanjianKerja.vue?vue&type=script&lang=js"
export * from "./perjanjianKerja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports